import { useState } from 'react';
import API from '../api/axios';

export default function PostForm() {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Please login first');
      window.location.href = '/login';
      return;
    }
    const formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    if (image) formData.append('image', image);

    try {
      await API.post('/posts', formData);
      alert('Post created!');
      // Optionally reset form
      setTitle('');
      setContent('');
      setImage(null);
    } catch (error) {
      if (error.response && error.response.status === 401) {
        alert('Unauthorized. Please login again.');
        localStorage.removeItem('token');
        window.location.href = '/login';
      } else {
        alert('Error creating post: ' + (error.response?.data?.error || error.message));
      }
    }
  };

  return (
    <form className="post-form" onSubmit={handleSubmit}>
      <input placeholder="Title" value={title} onChange={e => setTitle(e.target.value)} />
      <textarea placeholder="Write your post..." value={content} onChange={e => setContent(e.target.value)} rows={8} />
      <input type="file" onChange={e => setImage(e.target.files[0])} />
      <button type="submit">Publish</button>
    </form>
  );
}